import { useState } from "react";

const AccordionSection = ({ title, content }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b py-1 w-full md:w-1/2 px-2">
      <button
        onClick={() => setOpen(!open)}
        className="w-full text-left flex justify-between items-center text-lg font-semibold text-black"
      >
        {title}
        <span className="text-2xl">{open ? "−" : "+"}</span>
      </button>
      {open && (
        <ul className="list-disc list-inside text-base text-black mt-2 ml-6 space-y-1">
          {content.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default function ImportantInfoAccordion({ product }) {
  return (
    <div className="mt-6 border-t mx-2 md:mx-6">
      <h2 className="text-xl font-bold text-black py-4">Important Information</h2>

      {/* Flex layout for 2 columns on desktop */}
      <div className="flex flex-col md:flex-row md:flex-wrap">
        <AccordionSection title="Ingredients" content={product.ingredients} />
        <AccordionSection title="Directions" content={product.how_to_use} />
        <AccordionSection title="Benefits" content={product.benefits} />
        <AccordionSection title="Caution" content={product.caution} />
      </div>
    </div>
  );
}
